import { useState } from 'react';
import { resetUserPassword } from 'stores/userStore';
import TextInput from '../inputs/TextInput';
import Button, { ButtonWidth } from '../Button';
import styles from './styles/Form.module.scss';
import AuthModalHeader from './AuthModalHeader';
import { isEmailValid } from 'helpers/user';
import Spinner from '../Spinner';

export default function ResetPasswordForm({ register, forgotPassword }: { register: () => void; forgotPassword: () => void }) {
  const [email, setEmail] = useState<string | undefined>('');
  const [clientSideEmailError, setClientSideEmailError] = useState<boolean>(false);
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [resetSent, setResetSent] = useState<boolean>(false);
  const [resetErrors, setResetErrors] = useState<string[] | null>(null);

  function handleReset() {
    if (!email || !isEmailValid(email)) {
      setClientSideEmailError(true);
      return;
    }
    const resetPasswrod = async () => {
      setIsSaving(true);
      setClientSideEmailError(false);
      try {
        await resetUserPassword(email);
        setResetSent(true);
      } catch (errors: any) {
        setResetErrors(errors);
      } finally {
        setIsSaving(false);
      }
    };
    resetPasswrod();
  }
  return (
    <>
      <AuthModalHeader title={'Reset your password'} />
      <div className={styles.Form}>
        <div className={styles.Container}>
          <label htmlFor="email">Email</label>
          <TextInput onChange={val => setEmail(val)} value={email} placeholder="Email address" hasError={clientSideEmailError} />
          {clientSideEmailError && <div className={styles.Error}>Please enter a valid email address.</div>}
          {resetErrors?.length && (
            <>
              {resetErrors.map((error, index) => (
                <div className={styles.Error} key={`registration-error-${index}`}>
                  {error}
                </div>
              ))}
            </>
          )}
          {resetSent && <div>Password reset email sent, please check your email and follow the instructions there.</div>}
        </div>
        <Button width={ButtonWidth.FULL} className={styles.ResetPasswordButton} onClick={handleReset}>
          {isSaving ? <Spinner /> : 'Send Reset Link'}
        </Button>
        <div className={styles.Secondary}>
          Don't have an SBLive Sports account?&nbsp;<span onClick={register}>Sign Up</span>
        </div>
      </div>
    </>
  );
}
